<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-1">
              <div class="col-12 section_title">EDITAR CLIENTE</div>
            </div>
          </template>

          <template v-slot:end>
            <Button
              label="GUARDAR"
              icon="pi pi-save"
              class="p-button-success mr-2"
              @click="save()"
            />
          </template>
        </Toolbar>

        <div class="">
            <div class="formgrid grid">
              <div class="field col-6">
                <label for="name">Razón Social</label>
                <InputText
                  id="name"
                  v-model.trim="client.name"
                  required="true"
                  autofocus
                  class="inputfield w-full"
                  :class="{ 'p-invalid': submitted && !client.name }"
                />
                <small class="p-invalid" v-if="submitted && !client.name"
                  >Nombre es requerido.</small
                >
              </div>

              <div class="field col-2">
                <label for="name">Código</label>
                <InputText
                  id="code"
                  v-model.trim="client.code"
                  autofocus
                  class="inputfield w-full"
                />                
              </div>

              <div class="field col-2">
                <label for="name">CUIT</label>
                <InputText
                  id="cuit"
                  v-model.trim="client.cuit"
                  required="true"
                  autofocus
                  class="inputfield w-full"
                  :class="{ 'p-invalid': submitted && !client.cuit }"
                />
                <small class="p-invalid" v-if="submitted && !client.cuit"
                  >CUIT es requerido.</small
                >
              </div>
              <div class="field col-2">
                <label for="name">IIBB</label>
                <InputText
                  id="iibb"
                  v-model.trim="client.iibb"
                  required="true"
                  autofocus
                  class="inputfield w-full"
                  :class="{ 'p-invalid': submitted && !client.iibb }"
                />
                <small class="p-invalid" v-if="submitted && !client.iibb"
                  >IIBB es requerido.</small
                >
              </div>

            </div>
          

          <div class="">
            <div class="formgrid grid">
              <div class="field col-6">
                <label for="name">Dirección</label>
                <InputText
                  id="iibb"
                  v-model.trim="client.address"
                  required="true"
                  autofocus
                  class="inputfield w-full"
                  :class="{ 'p-invalid': submitted && !client.address }"
                />
                <small class="p-invalid" v-if="submitted && !client.address"
                  >Dirección es requerido.</small
                >
              </div>
              <div class="field col-2">
                <label for="location">Localidad</label>
                <InputText id="location" class="inputfield w-full" v-model="client.location" />
              </div>
              <div class="field col-2">
                <label for="province">Provincia</label>
                <InputText id="province" class="inputfield w-full" v-model="client.province" />
              </div>
              <div class="field col-2">
                <label for="cp">CP</label>
                <InputNumber id="cp" class="inputfield w-full" v-model="client.postalcode" integeronly />
              </div>
              
            </div>
          </div>

          <div class="">
            <div class="formgrid grid">
              <div class="field col-6">
                <label for="name">Email</label>
                <InputText
                  id="iibb"
                  v-model.trim="client.email"
                  autofocus
                  class="inputfield w-full"
                />                
              </div>
              <div class="field col-3">
                <label for="phone">Teléfono</label>
                <InputText id="phone" class="inputfield w-full" v-model="client.phone" />
              </div>
              <div class="field col-3">
                <label for="web">Web</label>
                <InputText id="web" class="inputfield w-full" v-model="client.web" integeronly />
              </div>
              
              
            </div>
          </div>


          <div class="">
            <div class="formgrid grid">
              <div class="field col-6">
                <label for="phone">Condición de Venta</label>
                <Dropdown
                    id="unidad"
                    v-model="client.condicion_venta_id"
                    :options="conditions"
                    class="w-full"
                    optionLabel="name"
                    optionValue="id"
                    required="false"
                    autofocus
                    :class="{ 'p-invalid': submitted && !client.condicion_venta_id }"
              />   
              </div>
              <div class="field col-6">
                <label for="web">Zona</label>
                <Dropdown
                    id="unidad"
                    v-model="client.zona_id"
                    :options="zonas"
                    class="w-full"
                    optionLabel="name"
                    optionValue="id"
                    required="false"
                    autofocus
                    :class="{ 'p-invalid': submitted && !client.zona_id }"
              />   
              </div>
              
              
            </div>
          </div>




        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="card">
        <div class="my-1">
          <div class="col-12 section_subtitle">Datos Impositivos</div>
        </div>

        <div class="">
          <div class="formgrid grid">
            <div class="field col-8">
              <label for="base">Situación IVA</label>
              <Dropdown
                    id="unidad"
                    v-model="client.type_client"
                    :options="client_types"
                    class="w-full"
                    optionLabel="name"
                    optionValue="id"
                    required="false"
                    autofocus
                    :class="{ 'p-invalid': submitted && !client.type_client }"
              />              

            </div>
            <div class="field col-4">
                <label for="formu">Nro. Agente SICOL</label>
                <InputText
                  v-model="client.numero_sicol"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />
              </div>

          </div>


          <div class="formgrid grid">
            <div class="field col-4">
              <label for="base">Ganancias</label>
              <Dropdown
                    id="unidad"
                    v-model="client.ganancias_id"
                    :options="client_types"
                    class="w-full"
                    optionLabel="name"
                    optionValue="id"
                    required="false"
                    autofocus
                    :class="{ 'p-invalid': submitted && !client.ganancias_id }"
              />              

            </div>

            <div class="field col-4">
              <label for="base">Ingresos Brutos</label>
              <Dropdown
                    id="unidad"
                    v-model="client.ingresos_brutos_id"
                    :options="client_types"
                    class="w-full"
                    optionLabel="name"
                    optionValue="id"
                    required="false"
                    autofocus
                    :class="{ 'p-invalid': submitted && !client.ingresos_brutos_id }"
              />              

            </div>
            <div class="field col-4">
                <label for="formu">Nro.</label>
                <InputText
                  v-model="client.numero"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />
              </div>

          </div>

        </div>


      </div>  

            
      <div class="card">
        <div class="my-1">
          <div class="col-12 section_subtitle">Lugar de Entrega</div>
        </div>

        <div class="">
          <div class="formgrid grid">
            <div class="field col-4">
              <label for="base">Código</label>
              <InputText
                  v-model="delivery_code"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />

            </div>
            <div class="field col-4">
              <label for="formu">Descripción</label>
              <InputText
                v-model="delivery_description"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>
            <div class="field col-4">
              <label for="formu">Lugar</label>
              <InputText
                v-model="delivery_place"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>

            <div class="field col-4">
              <label for="base">Localidad</label>
              <InputText
                  v-model="delivery_locality"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />

            </div>
            <div class="field col-4">
              <label for="formu">Provincia</label>
              <InputText
                v-model="delivery_province"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>
            <div class="field col-4">
              <label for="formu">Cód. Postal</label>
              <InputText
                v-model="delivery_zipcode"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>
            <div class="field col-8">
              <label for="formu">Horario</label>
              <InputText
                v-model="delivery_schedule"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>

          <div class="field col-4">
            <Button :disabled="!delivery_description && !delivery_place"  @click="addDeliveryData()" label="Agregar" 
              icon="pi pi-plus" class="p-button-success inputfield w-full mt-5" />

          </div>


          </div>
        </div>

        <div class="">
          <DataTable
            :value="delivery_data"
             dataKey="id" 
            class="p-datatable-sm"
            responsiveLayout="scroll"
          >
            <Column header="" >
              <template #body="slotProps">
                  <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="delItem(slotProps.data)"></Button>
              </template>
            </Column>
           <Column headerClass="" field="qty" header="Cód." headerStyle="max-width: 20%">
              <template #body="slotProps">
                {{ slotProps.data.code }}
              </template>
            </Column>
            <Column field="name" header="Descr.">
              <template #body="slotProps">
                {{slotProps.data.description}}
              </template>
            </Column>
            <Column field="valor" header="Lugar">
              <template #body="slotProps">
                {{slotProps.data.place}}
              </template>
            </Column>
             <Column header="Localidad">
                <template #body="slotProps">
                        <span>{{slotProps.data.locality}}</span>
                </template>
            ></Column>
          </DataTable>

        </div>
      </div>

      


    </div>

    <div class="col-6">

      <div class="card">
        <div class="my-1">
          <div class="col-12 section_subtitle">Otros Datos</div>

          <div class="">
          <div class="formgrid grid">
            <div class="field col-6">
                <label for="formu">Nombre Fantasia</label>
                <InputText
                  v-model="client.nombre_fantasia"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />
            </div>
            <div class="field col-6">
              <label for="base">Transporte</label>
              <Dropdown
                    id="unidad"
                    v-model="client.transporte_id"
                    :options="transportes"
                    class="w-full"
                    optionLabel="name"
                    optionValue="id"
                    required="false"
                    autofocus
                    :class="{ 'p-invalid': submitted && !client.transporte_id }"
              />              

            </div>

          </div>


          <div class="formgrid grid">
            <div class="field col-4">
              <label for="base">Lugar de Pago</label>
              <InputText
                  v-model="client.lugar_pago"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />
            </div>

            <div class="field col-4">
              <label for="base">Responsable Pago</label>
              <InputText
                  v-model="client.responsable_pago"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />
            </div>
            <div class="field col-4">
                <label for="formu">Horario de Pago</label>
                <InputText
                  v-model="client.horario_pago"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />
              </div>

          </div>

        </div>

        </div>

      </div>  

      <div class="card">
        <div class="my-1">
          <div class="col-12 section_subtitle">Contactos</div>

            <div class="">
              <div class="formgrid grid">
              
              <div class="field col-6">
              <label for="base">Nombre</label>
              <InputText
                  v-model="contact_name"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />

            </div>
            <div class="field col-6">
              <label for="formu">Email</label>
              <InputText
                v-model="contact_email"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>
            
            <div class="field col-4">
              <label for="base">Teléfono</label>
              <InputText
                  v-model="contact_phone"
                  id="formu"
                  type="text"
                  class="inputfield w-full"
                />

            </div>
            <div class="field col-4">
              <label for="formu">Celular</label>
              <InputText
                v-model="contact_cell"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>
            <div class="field col-4">
              <label for="formu">Cargo</label>
              <InputText
                v-model="contact_role"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>
            <div class="field col-8">
              <label for="formu">Otros datos</label>
              <InputText
                v-model="contact_other"
                id="formu"
                type="text"
                class="inputfield w-full"
              />
            </div>

          <div class="field col-4">
            <Button :disabled="!contact_name && !contact_phone"  @click="addContact()" label="Agregar" 
              icon="pi pi-plus" class="p-button-success inputfield w-full mt-5" />
          </div>  
              </div>
            </div>

            <div class="">
              <DataTable
                :value="contacts"
                 dataKey="id" 
                class="p-datatable-sm"
                responsiveLayout="scroll"
              >
                <Column header="" >
                  <template #body="slotProps">
                      <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="delContact(slotProps.data)"></Button>
                  </template>
                </Column>
               <Column headerClass="" field="name" header="Nombre" headerStyle="max-width: 20%">
                  <template #body="slotProps">
                    {{ slotProps.data.name }}                    
                  </template>
                </Column>
                <Column field="name" header="Email">
                  <template #body="slotProps">
                    {{ slotProps.data.email }}                    
                  </template>
                </Column>
                <Column field="valor" header="Telef.">
                  <template #body="slotProps">
                    {{ slotProps.data.email }}
                  </template>
                </Column>
                 <Column header="Celular">
                    <template #body="slotProps">
                    {{ slotProps.data.cell }}
                  </template>
                ></Column>
              </DataTable>

            </div>

        </div>
      </div>  

    </div>

  </div>
</template>

<script>
import CrudService from "./../../services/crud.service.js";

export default {
  data() {
    return {
      conditions: null,
      zonas: null,
      client_types: null,
      transportes: null,
      delivery_code: null,
      delivery_description: null,
      delivery_place: null,
      delivery_locality: null,
      delivery_schedule: null,
      delivery_zipcode: null,
      delivery_schedule: null, 
      contact_name: null,
      contact_email: null,
      contact_phone: null,
      contact_cell: null,
      contact_role: null,
      contact_other: null,
      contacts: [],

      clientDialog: false,
      deleteClientDialog: false,
      deleteClientsDialog: false,
      client: {},
      selectedClients: null,
      filters: {},
      submitted: false,
      validationErrors: [],

      routeName: null,
      mod: [],
      delivery_data: [],

      actualFormula: "",
      filteredClients: null,
      newItem: null,
      selectedClient: null,

      mods: null,
      newItemMOD: null,
      filteredMod: null,
      selectedMod : null,
      actualFormulaMOD: "",

      submitted: false,
      validationErrors: null,
    };
  },
  created() {
    this.routeName = this.$route.name;
  },
  mounted() {
    CrudService.getCRUD("cliente", this.$route.params.id).then((data) => {
      this.client = data;
      if (typeof this.client.type_client === 'string') {
        this.client.type_client = parseInt(data.type_client);
      }
      if (typeof this.client.condicion_venta_id === 'string') {
        this.client.condicion_venta_id = parseInt(data.condicion_venta_id);
      }
      if (typeof this.client.zona_id === 'string') {
        this.client.zona_id = parseInt(data.zona_id);
      }
      if (typeof this.client.ganancias_id === 'string') {
        this.client.ganancias_id = parseInt(data.ganancias_id);
      }
      if (typeof this.client.ingresos_brutos_id === 'string') {
        this.client.ingresos_brutos_id = parseInt(data.ingresos_brutos_id);
      }
      if (typeof this.client.transporte_id === 'string') {
        this.client.transporte_id = parseInt(data.transporte_id);
      }

      this.delivery_data = data.lugares_entrega;
      this.contacts = data.contactos;
    });
    CrudService.getCRUD("condiciones-venta").then((data) => (this.conditions = data));
    CrudService.getCRUD("zonas").then((data) => (this.zonas = data));
    CrudService.getCRUD("tipo-clientes").then((data) => (this.client_types = data));
    CrudService.getCRUD("transportes").then(data => {this.transportes = data; });
  },
  methods: {

    delItem(itemId){
      let index = this.delivery_data.findIndex(item => item.id == itemId);
      this.delivery_data.splice(index, 1);
    },
    delContact(itemId){
      let index = this.contacts.findIndex(item => item.id == itemId);
      this.contacts.splice(index, 1);
    },

      displayErrors(errors) {
      for (let key in errors) {
        this.validationErrors.push({ field: key, message: errors[key] });

        let error = errors[key];
        this.$toast.add({
          severity: "error",
          summary: "Error!",
          detail: error[0],
          life: 3000,
        });
      }
    },
    addDeliveryData() {
      if (! this.delivery_description) {
        this.$toast.add({
              severity: "info",
              summary: "Atención!",
              detail: "Debe indicar la descripción.",
              life: 3000,
            });
        return false;
      }
      if (! this.delivery_place) {
        this.$toast.add({
              severity: "info",
              summary: "Atención!",
              detail: "Debe indicar el lugar.",
              life: 3000,
            });
        return false;
      }
      
      this.delivery_data.push({
        code: this.delivery_code,
        place: this.delivery_place,
        description: this.delivery_description,        
        locality: this.delivery_locality,        
        province: this.delivery_province,        
        zipcode: this.delivery_zipcode,        
        schedule: this.delivery_schedule
      });

      this.delivery_code = null;
      this.delivery_place = null;
      this.delivery_description = null;        
      this.delivery_locality = null;        
      this.delivery_province = null;        
      this.delivery_zipcode = null;        
      this.delivery_schedule = null;
      
    },
    addContact() {
      if (! this.contact_name) {
        this.$toast.add({
              severity: "info",
              summary: "Atención!",
              detail: "Debe indicar el nombre.",
              life: 3000,
            });
        return false;
      }
      if (! this.contact_phone) {
        this.$toast.add({
              severity: "info",
              summary: "Atención!",
              detail: "Debe indicar el Teléfono.",
              life: 3000,
            });
        return false;
      }
      
      this.contacts.push({
        name: this.contact_name,
        email: this.contact_email,
        phone: this.contact_phone,        
        cell: this.contact_cell,        
        role: this.contact_role,        
        other: this.contact_other
      });

      this.contact_name = null;
      this.contact_email = null;
      this.contact_phone = null;
      this.contact_cell = null;
      this.contact_role = null;
      this.contact_other = null;
      
    },
    
    save() {
      this.submitted = true;

      this.client.delivery_data = this.delivery_data;
      this.client.contacts = this.contacts;

      CrudService.updateCRUD("cliente", "cliente", this.client).then(
        (data) => {
          this.validationErrors = [];
          if (data.status == 400) {
            this.displayErrors(data.data);
          } else {
            this.$toast.add({
              severity: "success",
              summary: "Éxito!",
              detail: "Creado correctamente.",
              life: 3000,
            });

            this.$router.push("/cliente");
          }
        }
      );
    },
  },
};
</script>


<style scoped>

  .section_subtitle {
    font-size: 1.2rem;
    font-weight: bold;
    color: #1261b1;
    margin-bottom: 1rem;
  }

  .card {
    padding-top: 0.25rem;
  }

</style>